import { Box, Button, Card, Container, Divider, Group, ScrollArea, Select, Table, TextInput } from "@mantine/core";
import QueryString from "qs";
import useSWR from "swr";
import dayjs from "dayjs";
import CardHeader from "@/components/CardHeader";
import { useSearchParams } from "react-router-dom";
import useAuthStore from "@/store/useAuthStore";
import RoutePagination from "@/components/RoutePagination";
import DetailModal from "./DetailModal";
import { useState } from "react";
import { useForm } from "@mantine/form";
import TableEmpty from "@/components/placeholders/TableEmpty";
import CompanySelector from "@/components/CompanySelector";
import TableImageViewer from "@/components/TableImageViewer";
import Empty from "@/components/placeholders/Empty";

export default function Items() {
  const user = useAuthStore((state) => state.user);
  const [searchParams, setSearchParams] = useSearchParams();
  const pageSize = useAuthStore((state) => state.pageSize);
  const page = searchParams.get("page") || 1;

  const form = useForm({
    initialValues: {
      name: searchParams.get("name") || "",
      company: Number(searchParams.get("company")) || "",
    },
  });

  const [sort, setSort] = useState("createdAt:desc");

  const params = QueryString.stringify({
    filters: {
      name: { $contains: searchParams.get("name") || undefined },
      company: user?.company?.id,
    },
    populate: "*",
    sort: [sort],
    pagination: {
      page,
      pageSize,
    },
  });

  const title = "상차품";
  const url = "/items";
  const { data, mutate, isLoading } = useSWR([url, params]);
  const list = data?.data || [];
  console.log("🚀", data?.data);

  if (!user?.company?.id)
    return <Empty title="Error" text={`회사 정보를 찾을 수 없습니다. ${JSON.stringify(user?.company?.id)}`} />;

  return (
    <Container fluid>
      <Card>
        <CardHeader
          title={`${title} 관리`}
          action={<DetailModal item={null} mutate={mutate} id={null} title={title} url={url} />}
        />

        <Card.Section withBorder>
          <form onSubmit={form.onSubmit((vals) => setSearchParams({ page: 1, ...vals }))}>
            <Box my="sm" mx="md">
              <Group position="left">
                <Select
                  mb={0}
                  maw={150}
                  data={[
                    { value: "createdAt:desc", label: "등록일시 ▼" },
                    { value: "createdAt:asc", label: "등록일시 ▲" },
                  ]}
                  value={sort}
                  onChange={setSort}
                />
                <Divider orientation="vertical" />
                <TextInput maw={150} mb={0} placeholder="상차품명" {...form.getInputProps("name")} />

                <Button
                  variant="outline"
                  onClick={() => {
                    setSearchParams({ page: 1 });
                    form.reset();
                  }}
                >
                  초기화
                </Button>
                <Button type="submit">검색</Button>
              </Group>
            </Box>
          </form>
        </Card.Section>

        <Card.Section>
          <ScrollArea>
            <Table>
              <thead>
                <tr>
                  <th className="tc">#</th>
                  <th className="tl">상차품명</th>
                  <th className="tl">설명</th>
                  <th className="tc">이미지</th>
                  <th className="tc">등록일</th>
                  <th className="tc">관리</th>
                </tr>
              </thead>
              <tbody>
                {!isLoading && list.length === 0 && (
                  <TableEmpty title="내역 없음" text="해당되는 내역이 조회되지 않습니다" />
                )}

                {list.map((row, idx) => {
                  const item = row.attributes || {};

                  return (
                    <tr key={row.id}>
                      <td className="tc">{idx + (page - 1) * pageSize + 1}</td>
                      <td className="tl">{item.name}</td>
                      <td className="tl">{item.description || "-"}</td>
                      <td className="tc">
                        <TableImageViewer url={item?.image?.data?.attributes?.url} />
                      </td>
                      <td className="tc">{dayjs(item.createdAt).format("YYYY-MM-DD")}</td>
                      <td className="tc">
                        <DetailModal item={item} mutate={mutate} id={row.id} title={title} url={url} />
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </ScrollArea>
        </Card.Section>

        <RoutePagination total={data?.meta?.pagination?.pageCount} page={page} setSearchParams={setSearchParams} />
      </Card>
    </Container>
  );
}
